module.exports = __webpack_public_path__ + "static/media/ir.a03528af.svg";